import React from "react";
import {loadState} from "../lib/actions";
import {connect} from "react-redux";

class PreviewsInput extends React.Component {
    constructor(props) {
        super(props);
        this.inputField = React.createRef();
    }

    onChange(value) {
        if (/[^a-zA-Z0-9&]/.test(value)) {
            return;
        }

        this.props.onChange(value.toUpperCase());
    }

    componentDidMount() {
        this.inputField.current.focus();
    }

    render() {
        return (
            <>
                <div className='customizer-input'>
                    <div className="customizer-input__line">
                        <input placeholder='type here' ref={this.inputField} maxLength={6} className='customizer-input__field' type='text' value={this.props.input} onChange={(e) => this.onChange(e.target.value)}/>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        input: state.input,
        orientation: state.necklaceOrientation,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (input) => {
            let earringInputOne = input;
            let earringInputTwo = input;

            if (input.length > 3) {
                earringInputOne = input.slice(0, 3);
                earringInputTwo = input.slice(3, 7);
            }

            dispatch(loadState({
                input: input,
                input2: input,
                earringInput: [earringInputOne, earringInputTwo, earringInputOne, earringInputTwo],
            }));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewsInput);
